"use client";
import Actionable from "../Actionable/index.js";
import Button from "../Button/index.js";
import Icon from "../Icon/index.js";
import Text from "../Text/index.js";
import Theme from "../Theme/index.js";
import View from "../View/index.js";
import X from "../../icons/X.js";
import React from "react";
import ToastContext from "./Toast.context.js";
import s from "./Toast.module.css";
const Toast = (props) => {
    const { hide } = React.useContext(ToastContext);
    const { id, size = "small", text, children, color = "inverted", icon, title, actionsSlot, startSlot, hideDismiss = false, collapsed, className, attributes, } = props;
    let backgroundColor = color === "inverted" || color === "neutral" ? "elevation-overlay" : color;
    if (color === "neutral")
        backgroundColor = collapsed ? "neutral" : "elevation-overlay";
    const borderColor = color === "neutral" ? "neutral-faded" : "transparent";
    const textTagName = size === "small" ? "span" : "div";
    const isLarge = size === "large";
    let actions = [];
    if (actionsSlot) {
        actions = Array.isArray(actionsSlot) ? actionsSlot : [actionsSlot];
    }
    const textContent = (title || text) && (React.createElement(React.Fragment, null,
        title && (React.createElement(Text, { variant: "body-3", weight: "semibold", as: textTagName },
            title,
            " ")),
        React.createElement(Text, { variant: "body-3", as: textTagName }, text)));
    const toastNode = (React.createElement(View, { backgroundColor: backgroundColor, borderColor: borderColor, padding: 4, borderRadius: "medium", animated: true, direction: "row", gap: 3, align: isLarge ? "start" : "center", className: [s.toast, className], attributes: attributes },
        icon && React.createElement(Icon, { size: 5, svg: icon, className: s.icon }),
        startSlot && !icon && React.createElement(View.Item, null, startSlot),
        React.createElement(View.Item, { grow: true },
            React.createElement(View, { direction: isLarge ? "column" : "row", align: isLarge ? "start" : "center", gap: 3 },
                React.createElement(View.Item, { grow: true }, (textContent && children) || size !== "small" ? (React.createElement(View, { gap: 0.5 },
                    textContent,
                    children && React.createElement(View, { gap: 3 }, children))) : (textContent || children)),
                actions.length && (React.createElement(View, { direction: "row", align: "center", gap: 2 }, actions.map((slot, index) => {
                    const isPrimary = size === "large" ? index === 0 : index === actions.length - 1;
                    const primaryColor = color === "neutral" || color === "inverted" ? "neutral" : "white";
                    const defaultProps = {
                        variant: isPrimary ? "solid" : "ghost",
                        size: "small",
                        color: isPrimary ? primaryColor : "inherit",
                        elevated: color !== "neutral",
                    };
                    if (slot.type === Button) {
                        return React.createElement(Button, { ...defaultProps, ...slot.props, key: index });
                    }
                    else {
                        return slot;
                    }
                }))))),
        !hideDismiss && (React.createElement(View, { align: isLarge ? "start" : "center" },
            React.createElement(Actionable, { attributes: { "aria-label": "dismiss" }, onClick: () => hide(id) },
                React.createElement(Icon, { svg: X, size: 4, color: "neutral-faded" }))))));
    if (color === "inverted") {
        return React.createElement(Theme, { colorMode: "inverted" }, toastNode);
    }
    return toastNode;
};
export default Toast;
